export default __webpack_public_path__ + "static/media/sterlingimglogo.a6a13ec9.svg";